import { HttpErrorResponse } from '@angular/common/http';
import { type ErrorHandler, Injectable, inject, NgZone } from '@angular/core';
import { ErrorDialogService } from './error-dialog.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private errorDialogService = inject(ErrorDialogService);
  private zone = inject(NgZone);

  handleError(error: unknown) {
    let message = '';

    // Communication errors are handled differently to other errors
    if (error instanceof HttpErrorResponse) {
      message = 'A error occurred while communicating with the server';
    } else {
      message = (error as Error).message;
      // TODO [#215]: use winston for logging
      console.error(error);
    }
    this.zone.run(() =>
      this.errorDialogService.openDialog(message || 'Undefined client error', (error as HttpErrorResponse)?.status)
    );

    // TODO [#215]: use winston for logging
    console.debug('Error from global error handler', error);
  }
}
